class GridPostRowController {
    constructor($transclude) {
        this.transclude = $transclude;
    }

    $onInit() {
        this.grid.addPostRow(this);
    }
}

GridPostRowController.$inject = ['$transclude'];

const gridPostRowDirective = {
    restrict: 'E',
    scope: true,
    controller: GridPostRowController,
    controllerAs: 'gridPostRowCtrl',
    bindToController: {
        animateOnShow: '<?'
    },
    transclude: true,
    require: {
        grid: '^ctxGrid'
    }
};

module.exports = function () {
    return gridPostRowDirective;
};



// WEBPACK FOOTER //
// ./src/shared/ctxGrid/ctxGridPostRow.directive.js